module.exports = __webpack_public_path__ + "static/img/360speed.560ef59a.png";